<template>
  <div class="stu-info-root">
    <div class="info-wrap">
      <h3 class="title">报名信息</h3>
      <div class="unit-wrap fo-wrap info-cont-wrap">
        <div class="fo-list">
          <div class="fo-item w_all">
            <div class="i_info clearfix">
              <span class="label">报名名称:</span>
              <span class="text">{{info.enrollMap.enroll_name}}</span>
            </div>
          </div>
          <div class="fo-item w_all" style="display: flex">
            <div class="i_info clearfix" style="width: 50%">
              <span class="label">注册协会:</span>
              <span class="text">{{info.enrollMap.org_name}}</span>
            </div>
            <div class="i_info clearfix" style="width: 50%">
              <span class="label">报名类型:</span>
              <span class="text">{{info.enrollMap.enroll_type | enrollType}}</span>
            </div>
          </div>
<!--          <div class="fo-item w_all">-->
<!--            <div class="i_info clearfix">-->
<!--              <span class="label">报名类型:</span>-->
<!--              <span class="text">{{info.enrollMap.enroll_type | enrollType}}</span>-->
<!--            </div>-->
<!--          </div>-->
          <div class="fo-item w_all" v-if="info.enrollMap.enroll_type==='common'">
            <div class="i_info clearfix">
              <span class="label">主要身份:</span>
              <span class="text">{{info.enrollMap.identityName || '--' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="info-wrap" v-show="info.enrollMap.is_choose_classDate">
      <h3 class="title">意向参加培训班月份</h3>
      <div class="lan-wrap fo-wrap info-cont-wrap">
        <div class="fo-list">
          <span style="margin-left: 10px">{{info.enrollMap.intention_class_date | intentionClassDate}}</span>
        </div>
      </div>
    </div>
    <div class="info-wrap" v-show="info.report_list.length>0">
      <h3 class="title">报名文件</h3>
      <div class="lan-wrap fo-wrap info-cont-wrap">
        <div class="fo-list" >
          <div style="width: 50%" v-if="info.enrollMap.medical_date > 0">
            <span class="label file_label" style="margin-left: 5px">体检时间 :</span>
            <span style="margin-left: 10px" v-if="info.enrollMap.medical_date">{{info.enrollMap.medical_date | time(false)}}</span>
            <span style="margin-left: 10px" v-else>--</span>
          </div>
          <div class="fo-item w_one_third_file" v-for="(item,index) in info.report_list" :key="index">
            <div class="i_info">
              <span class="label" v-if="item.report_type === 'Physical'">体检报告 :</span>
              <span class="label file_label" v-if="item.report_type === 'Accident'">人身意外保险 :</span>
              <span class="label file_label" style="width: 89px" v-if="item.report_type === 'jobProof'">在职证明 :</span>
              <a :href="item.report_address" class="downfile" target="_blank" v-if="/^.*\.(pdf)$/i.test(item.report_address)">查看</a>
              <span @click="downloadFile(item.report_address)" class="downfile">下载</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="info-wrap">
      <h3 class="title">个人信息</h3>
      <div class="person-wrap fo-wrap info-cont-wrap">
        <div class="img-list">
          <div class="img-box ident">
            <img
              class="img"
              :src="idImg1Err ? identify1 : info.studentSingnInfo.id_card_photo_front"
              @error="idImg1Err=true"
            >
          </div>
          <div class="img-box ident">
            <img
              class="img"
              :src="idImg2Err ? identify2 :info.studentSingnInfo.id_card_photo_verso"
              @error="idImg2Err=true"
            >
          </div>
          <div class="passport img-box">
            <img
              class="img"
              :src="avatorErr ? avatorImg :info.studentSingnInfo.profile_picture"
              @error="avatorErr=true"
            >
          </div>
        </div>
        <div class="fo-list">
          <div class="fo-item w_half">
            <div class="i_info clearfix">
              <span class="label">姓名:</span>
              <span class="text texthide">{{info.studentSingnInfo.name | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info clearfix">
              <span class="label">手机:</span>
              <span class="text texthide">{{info.studentSingnInfo.mobile_phone | tranNull}}</span>
            </div>
          </div>
          <template v-if="info.studentSingnInfo.family_name_spell && info.studentSingnInfo.given_name_spell===''">
            <div class="fo-item w_half">
              <div class="i_info clearfix">
                <span class="label">姓名(拼音):</span>
                <span class="text texthide">{{info.studentSingnInfo.family_name_spell | tranNull}}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info clearfix">

              </div>
            </div>
          </template>
          <template v-else>
            <div class="fo-item w_half">
              <div class="i_info clearfix">
                <span class="label">姓氏(拼音):</span>
                <span class="text texthide">{{info.studentSingnInfo.family_name_spell | tranNull}}</span>
              </div>
            </div>
            <div class="fo-item w_half">
              <div class="i_info clearfix">
                <span class="label">名(拼音):</span>
                <span class="text texthide">{{info.studentSingnInfo.given_name_spell | tranNull}}</span>
              </div>
            </div>
          </template>
          <div class="fo-item w_half">
            <div class="i_info clearfix">
              <span class="label">曾用名:</span>
              <span class="text texthide">{{info.studentSingnInfo.former_name | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info clearfix">
              <span class="label">民族:</span>
              <span class="text texthide">{{info.studentSingnInfo.nation | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info clearfix">
              <span class="label">国籍:</span>
              <span class="text texthide">{{info.studentSingnInfo.nationality | tranCountry}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info clearfix">
              <span class="label">护照号:</span>
              <span class="text texthide">{{info.studentSingnInfo.passport | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info clearfix">
              <span class="label">性别:</span>
              <span class="text texthide">{{info.studentSingnInfo.gender === "Male" ? "男" : "女"}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info clearfix">
              <span class="label">出生日期:</span>
              <span class="text texthide">{{info.studentSingnInfo.birthday | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info clearfix">
              <span class="label">身高:</span>
              <span class="text texthide">{{info.studentSingnInfo.height | tranNull}}cm</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info clearfix">
              <span class="label">体重:</span>
              <span class="text texthide">{{info.studentSingnInfo.weight | tranNull}}kg</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info clearfix">
              <span class="label">证件类型:</span>
              <span class="text texthide">{{info.studentSingnInfo.id_type | getNumberType}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info clearfix">
              <span class="label">证件号:</span>
              <span class="text texthide">{{info.studentSingnInfo.id_number | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info clearfix">
              <span class="label">电子邮箱:</span>
              <span class="text texthide">{{info.studentSingnInfo.email_address | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info clearfix">
              <span class="label">固定电话:</span>
              <span class="text texthide">{{info.studentSingnInfo.contact_numbers | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info clearfix">
              <span class="label">邮编(家):</span>
              <span class="text texthide">{{info.studentSingnInfo.postcode | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info clearfix">
              <span class="label">传真(家):</span>
              <span class="text texthide">{{info.studentSingnInfo.fax_personage | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_all">
            <div class="i_info clearfix">
              <span class="label">通讯地址:</span>
              <span class="text">{{info.studentSingnInfo.contact_address | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_all">
            <div class="i_info clearfix">
              <span class="label">伤病历史:</span>
              <span class="text">{{info.studentSingnInfo.medical_history | tranNull}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="info-wrap">
      <h3 class="title">单位信息</h3>
      <div class="unit-wrap fo-wrap info-cont-wrap">
        <div class="fo-list">
          <div class="fo-item w_all">
            <div class="i_info clearfix">
              <span class="label">单位名称:</span>
              <span class="text">{{info.studentSingnInfo.club_name | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_all">
            <div class="i_info clearfix">
              <span class="label">单位地址:</span>
              <span class="text">{{info.studentSingnInfo.club_address | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info clearfix">
              <span class="label">单位邮编:</span>
              <span class="text texthide">{{info.studentSingnInfo.club_postcode | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info clearfix">
              <span class="label">电话:</span>
              <span class="text texthide">{{info.studentSingnInfo.club_telephone | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info clearfix">
              <span class="label">传真:</span>
              <span class="text texthide">{{info.studentSingnInfo.club_fax | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info clearfix">
              <span class="label">网址:</span>
              <span class="text texthide">{{info.studentSingnInfo.club_website | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info clearfix">
              <span class="label">电子邮箱:</span>
              <span class="text texthide">{{info.studentSingnInfo.club_email | tranNull}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="info-wrap">
      <h3 class="title">装备尺码</h3>
      <div class="wear-wrap fo-wrap info-cont-wrap">
        <div class="fo-list">
          <div class="fo-item w_half">
            <div class="i_info">
              <span class="label">套服:</span>
              <span class="text texthide">{{info.studentSingnInfo.track_suit | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info">
              <span class="label">T恤:</span>
              <span class="text texthide">{{info.studentSingnInfo.polo_T | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info">
              <span class="label">短裤:</span>
              <span class="text texthide">{{info.studentSingnInfo.shorts | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info">
              <span class="label">跑步鞋号:</span>
              <span class="text texthide">{{info.studentSingnInfo.track_shoes | tranNull}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="info-wrap" v-show="info.language_list.length>0">
      <h3 class="title">外语</h3>
      <div class="lan-wrap fo-wrap info-cont-wrap">
        <div class="fo-list" v-for="(item,index) in info.language_list" :key="index">
          <div class="fo-item w_one_third">
            <div class="i_info">
              <span class="label">语种:</span>
              <span class="text texthide">{{item.language_ids | tranLang}}</span>
            </div>
          </div>
          <div class="fo-item w_one_third">
            <div class="i_info">
              <span class="label">口语:</span>
              <span class="text texthide">{{item.spoken | tranSpoken}}</span>
            </div>
          </div>
          <div class="fo-item w_one_third">
            <div class="i_info">
              <span class="label">书写:</span>
              <span class="text texthide">{{item.written | tranSpoken}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="info-wrap" v-show="info.academic_data.length>0">
      <h3 class="title">最高学历</h3>
      <div class="edu-wrap fo-wrap info-cont-wrap">
        <div class="fo-list" v-for="(item, index) in info.academic_data" :key="index">
          <div class="fo-item w_half">
            <div class="i_info">
              <span class="label">起止日期:</span>
              <span
                class="text texthide"
              >{{item.academic_start_date | tranNull}} -- {{item.academic_end_date | tranNull }}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info">
              <span class="label">地点:</span>
              <span class="text texthide">{{item.academic_address | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info">
              <span class="label">学校:</span>
              <span class="text texthide">{{item.academic_venue | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info">
              <span class="label">学历/职称:</span>
              <span class="text texthide">{{item.qualification | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info">
              <span class="label">证明人:</span>
              <span class="text texthide">{{item.references_man | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info">
              <span class="label">联系方式:</span>
              <span class="text texthide">{{item.contact_details | tranNull}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="info-wrap" v-show="info.coach_data.length>0">
      <h3 class="title">等级教练员证书培训历程</h3>
      <div class="leval-wrap fo-wrap info-cont-wrap">
        <div class="fo-list" v-for="(item, index) in info.coach_data" :key="index">
          <div class="fo-item w_half">
            <div class="i_info">
              <span class="label">起止日期:</span>
              <span
                class="text texthide"
              >{{item.train_start_date | tranNull }} -- {{item.train_end_date | tranNull }}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info">
              <span class="label">地点:</span>
              <span class="text texthide">{{item.train_address | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info">
              <span class="label">何等级:</span>
              <span class="text texthide">{{item.train_certificate | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info">
              <span class="label">证书编号:</span>
              <span class="text texthide">{{item.certificate_number | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info">
              <span class="label">主讲师:</span>
              <span class="text texthide">{{item.train_references | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info">
              <span class="label">联系方式:</span>
              <span class="text texthide">{{item.train_contact_details | tranNull}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="info-wrap" v-show="info.experience_data.length>0">
      <h3 class="title">主要执教经历</h3>
      <div class="teach-wrap fo-wrap info-cont-wrap">
        <div class="fo-list" v-for="(item, index) in info.experience_data" :key="index">
          <div class="fo-item w_half">
            <div class="i_info">
              <span class="label">起止日期:</span>
              <span
                class="text texthide"
              >{{item.coach_start_date | tranNull }} -- {{item.coach_end_date | tranNull }}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info">
              <span class="label">任何职:</span>
              <span class="text texthide">{{item.coach_position | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info">
              <span class="label">证明人:</span>
              <span class="text texthide">{{item.coach_references | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info">
              <span class="label">联系方式:</span>
              <span class="text texthide">{{item.coach_contact_details | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_all">
            <div class="i_info">
              <span class="label">执教球队:</span>
              <span class="text">{{item.coach_team | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_all">
            <div class="i_info">
              <span class="label">地点:</span>
              <span class="text">{{item.coach_address | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_all">
            <div class="i_info">
              <span class="label">主要成绩:</span>
              <span class="text">{{item.coach_achievements | tranNull}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="info-wrap" v-show="info.playing_data.length>0">
      <h3 class="title">主要运动经历</h3>
      <div class="play-wrap fo-wrap info-cont-wrap">
        <div class="fo-list" v-for="(item, index) in info.playing_data" :key="index">
          <div class="fo-item w_half">
            <div class="i_info">
              <span class="label">起止日期:</span>
              <span
                class="text texthide"
              >{{item.play_start_date | tranNull }} -- {{item.play_end_date | tranNull }}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info">
              <span class="label">球队级别:</span>
              <span class="text texthide">{{item.play_team_level | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info">
              <span class="label">主教练:</span>
              <span class="text texthide">{{item.play_references | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_half">
            <div class="i_info">
              <span class="label">联系方式:</span>
              <span class="text texthide">{{item.play_contact_details | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_all">
            <div class="i_info">
              <span class="label">所在球队:</span>
              <span class="text">{{item.play_team | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_all">
            <div class="i_info">
              <span class="label">地点:</span>
              <span class="text">{{item.play_address | tranNull}}</span>
            </div>
          </div>
          <div class="fo-item w_all">
            <div class="i_info">
              <span class="label">主要成绩:</span>
              <span class="text">{{item.play_achievements | tranNull}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import identify1 from "@/assets/images/vita/identify1.png";
import identify2 from "@/assets/images/vita/identify2.png";
import avatorImg from "@/assets/images/person.png";
import {country} from "@/assets/js/country";
import {language, languageArr} from "@/assets/js/language";
import commonFun from "@/assets/js/yioks";
import { enroll_type,NumberTypes } from "@/assets/js/status";
const { downfile } = commonFun;

const spokenObj = {
  "good": "好",
  "normal": "一般",
  "poor": "差"
};
export default {
  name: 'StuDeatilInfo',
  props: {
    info: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      idImg1Err: false,
      idImg2Err: false,
      avatorErr: false,
      identify1,
      identify2,
      avatorImg,
    }
  },
  filters: {
    tranCountry(v) {
      if (v) {
        if(v === '--') {
            return '--';
          } else {
            return country[String(v)];
          }
      }
      else return "--";
    },
    intentionClassDate(dates){
      let str = '';
      if(dates && dates!== '[]'){
        const dataList =JSON.parse(dates);
        for(let i = 0 ; i < dataList.length ; i++){
          str +=  dataList[i] + '，';
        }
        if(str !== ''){
          str = str.substring(0,str.length-1);
        }else{
          str = '--';
        }
      }else{
        str = '--';
      }
      return str;
    },
    getBirthday(id_number) {
        if(!id_number || id_number.length != 18) {
          return "--";
        }else {
          if(id_number === '--') {
            return '--';
          } else {
            return id_number.substr(6, 4) + "-" + id_number.substr(10, 2) + "-" + id_number.substr(12, 2);
          }
        }
    },
    tranLang(v) {
      if (v) return language[String(v)];
      else return "--";
    },
    enrollType(type){
      return enroll_type(type)
    },
    tranNull(v) {
      return v || "--";
    },
    tranSpoken(v) {
      if (v) return spokenObj[v];
      else return "--";
    },
    getNumberType(type){
      return NumberTypes(type)
    }
  },
  methods: {
    downloadFile(url) {
      downfile(url);
    },
  },
  destroyed() {
    this.avatorErr=false;
    this.idImg2Err=false;
    this.idImg1Err=false;
  }
}
</script>


<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'

$margin = 5px

.stu-info-root
  display block
  .fo-wrap
    display block
    .fo-list
      display flex
      flex-wrap wrap
      align-items flex-start
      margin-left -($margin)
      margin-right -($margin)
      &:not(:last-child)
        border-bottom 1px dashed #ccc
      &+.fo-list
        margin-top 15px
      .fo-item
        display inline-block
        padding-right $margin
        padding-left $margin
        margin-bottom 6px
        .i_info
          display block
  .label
    float left
    width 90px
    text-align right
    padding-right 5px
    &+.text
      display block
      margin-left 80px
      &.texthide
        over_hide()
  .file_label
    width 120px
  .downfile
    cursor pointer
    color $color_primary
    margin-left 10px
  .w_half
    width 50%
  .w_all
    width 100%
  .w_one_third
    width 33.33333333333333%
  .w_one_third_file
    width 50%
  .info-wrap
    display block
    &+.info-wrap
      margin-top 15px
    .info-cont-wrap
      padding 0 10px
    .title
      display block
      font-weight bolder
      font-size 18px
      line-height 1
      padding-bottom 8px
      border-bottom 1px solid #ccc
      margin-bottom 10px
    .person-wrap
      .img-list
        display flex
        justify-content space-between
        margin-bottom 15px
        .img
          width 100%
          display block
        .ident
          width 38%
        .passport
          width 20%
</style>

